import { useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import { getTranslations } from "@/components/MyFavorites/v1/MyList/localization"
import { PRODUCT_BEST_SELLERS } from "@/constants/routes"

const EmptyListPage = () => {
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const router = useRouter()
  const handleBestSellersBtn = () => {
    router.push(PRODUCT_BEST_SELLERS)
  }

  return (
    <div className="userListEmptyContainer">
      <div className="userListEmptyText">{staticText?.listPageEmptyText}</div>
      <div className="bestSellersBtn" onClick={handleBestSellersBtn}>
        <div className="bestSellersBtnTxt">{staticText?.bestSellers}</div>
      </div>
    </div>
  )
}
export default EmptyListPage
